import { TripChecklistTab } from '../components/TripChecklistTab';

export function PackingTab({ tripId }: { tripId: string }) {
  return (
    <TripChecklistTab
      tripId={tripId}
      kind="packing"
      templateSectionTitle="Add packing list from template"
      templateDescription="Templates stay unchanged — items are copied into this trip only."
      emptyMessage="No packing lists on this trip yet. Pick a template above."
      addPlaceholder="Add item…"
      sectionLabels={{ open: 'To pack', done: 'Packed' }}
    />
  );
}
